import axios from "axios";

export function detectCourier(tracking) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/courier/detect`, {
        params: {
          tracking: tracking,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
